import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import AuthService from './services/authService'
import 'mdui/mdui.css'
import 'mdui'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// 添加路由守卫
router.beforeEach((to, from, next) => {
    // 检查目标路由是否需要认证
    if (to.name !== 'Login' && !AuthService.isLoggedIn()) {
        // 如果用户未登录且访问的不是登录页面，则重定向到登录页面
        next({ name: 'Login' })
    } else {
        // 其他情况允许访问
        next()
    }
})

const app = createApp(App)
app.use(createPinia())
app.use(router)
app.use(ElementPlus)
app.mount('#app')